import React from "react";
import "./styles.css";
import Header from "../../components/header";

const MainLayout = ({ children }) => {
  return (
    <div className="main-layout">
      <Header />
      <main>{children}</main>
    </div>
  );
};

export default MainLayout;
